import { CloseIcon, Dialog, DialogProps } from "@fluentui/react-northstar";
import React from "react";

type Props = DialogProps & {
  minHeight?: number | string;
  maxWidth?: number | string;
  minWidth?: number | string;
  width?: number | string;
  onCancel: () => void;
  hideHeaderAction?: boolean;
};

export const PollyDialog: React.FC<Props> = ({
  onCancel,
  maxWidth,
  minWidth,
  minHeight,
  width,
  children,
  hideHeaderAction,
  ...dialogProps
}) => {
  return (
    <Dialog
      styles={{
        width: width || "66vw",
        minWidth,
        maxWidth,
        overflowY: "auto",
        minHeight,
        padding: "1rem",
      }}
      headerAction={
        !hideHeaderAction
          ? {
              iconOnly: true,
              text: true,
              icon: <CloseIcon size="large" />,
              onClick: e => {
                e.stopPropagation();
                onCancel();
              },
            }
          : null
      }
      onCancel={() => onCancel()}
      content={children}
      {...dialogProps}
    />
  );
};
